import { cn } from '@/lib/utils';
import React from 'react';

type As = keyof JSX.IntrinsicElements;

type TextVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'body1'
  | 'body2'
  | 'body3';

type weight = 'normal' | 'medium' | 'semibold' | 'bold';

interface TextProps {
  as?: As;
  variant?: TextVariant;
  children: React.ReactNode;
  className?: string;
  weight?: weight;
}

const variantStyles: Record<TextVariant, string> = {
  h1: 'text-4xl',
  h2: 'text-[2.25rem] leading-10',
  h3: 'text-[2rem] leading-10',
  h4: 'text-[1.5rem] leading-8',
  h5: 'text-2xl leading-7',
  h6: 'text-[1.125rem] leading-6',
  body1: 'text-base leading-5',
  body2: 'text-sm leading-5',
  body3: 'text-xs leading-4',
};

const fontWeightStyles: Record<weight, string> = {
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
};

const Text: React.FC<TextProps> = ({
  as,
  variant = 'body1',
  children,
  className,
  weight = 'normal',
}) => {
  const Tag = as || 'p';

  return (
    <Tag
      className={cn(
        variantStyles[variant],
        fontWeightStyles[weight],
        'text-neutral-900',
        className
      )}
    >
      {children}
    </Tag>
  );
};

export default Text;
